var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"statistics-status d-flex"},[(_vm.status > 0)?_c('img',{attrs:{"src":"/assets/icons/stock-up.svg"}}):_c('img',{attrs:{"src":"/assets/icons/stock-up.svg"}}),_c('div',{staticClass:"value mx-1",class:{ positive: _vm.status > 0, negative: _vm.status < 0 }},[_vm._v(" "+_vm._s(_vm.status)+"% ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }